const isValidUrl = (url = '') => {
    try {
        const { protocol } = new URL(url);
        return protocol.startsWith('https:');
    } catch (error) {
        return false;
    }
};

export default isValidUrl;
